import { Headers, Http, Response } from "@angular/http";
import { Injectable } from "@angular/core"; //SEMPRE USA O DECORATION INJECTABLE

//PARA TRABALHAR COM O OBSERVABLE
import { Observable } from "rxjs/Observable";

import { Task } from "./task.model";

//DECLARA O INJECTABLE
@Injectable()
/* CLASSE PREINCIPAL DO SERVIÇO 
 *
 * RESPONSÁVEL POR IR ATÉ O SERVIDOR/DB E PEGAR OS DADOS
*/
export class TaskService {

  //CRIA UMA VAR QUE RECEBE O CAMINHO
  //public tasksUrl = 'http://localhost/my.api.com.br/task/';
  //public tasksUrl = 'http://localhost/my.api.com.br/api/books';
  public tasksUrl = 'http://www.agenciasnet.com.br/api/task/';

  //HEADER PARA AS REQUISIÇÕES DELETE, CREAT E UPDATE
  public headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

  /**
   * constructor
   */
  public constructor(private http: Http) {}

  /**
     * getTasks
     */
  // public getTasks(): Promise<Task[]>{
  //     let promise = new Promise(function(resolve, reject){
  //         if(TASKS.length > 0){
  //             resolve(TASKS);
  //         }else{
  //             let error_msg = "NAO HA TAREFAS";
  //             reject(error_msg);
  //         }
  //     })

  //     return promise;

  // }

  /**
    * getTasks
    * MÉTODO RESPONSÁVEL POR PEGAR AS TAREFAS
  */
  // public getAll(): Observable<Task[]>{
  //   return this.http.get(this.tasksUrl)
  //     .catch(this.handleErrors)//FAZ O TRATAMENTO DO ERRO
  //     .map((response: Response) => response.json().data as Task[] ); //RECEBE A RESPOSTA, CONVERTE EM JSON E SETA COMO UM ARRAY DE TAREFAS
  // }

  public getAll(): Observable<Task[]>{
    return this.http.get(this.tasksUrl + "tasks")
      //.catch(this.handleErrors)//FAZ O TRATAMENTO DO ERRO
      .map((response: Response) => {
        let collection = response.json();
        let tasks: Task[] = [];

        //console.log(collection);

        collection.forEach(item => {
          let task = new Task(
            item.id,
            item.title,
            item.description,
            item.done,
            item.deadline
          );

          tasks.push(task);
        })

        return tasks;

      }); //RECEBE A RESPOSTA, CONVERTE EM JSON E SETA COMO UM ARRAY DE TAREFAS
  }

  /**
   * getImportantTasks
   * : Promise<Task[]>  */
  public getImportant(): Observable<Task[]> {

    return this.getAll()
    .catch(this.handleErrors)//FAZ O TRATAMENTO DO ERRO
    .map(tasks => tasks.slice(0, 4));//PEGA AS 4 PRIMEIRAS TAREFAS DO ARRAY
  }

  /**
   * getTask
   * id: number : Promise<Task>  
   * MÉTODO RESPONSÁVEL PARA PEGAR UMA TAREFA PELO ID*/
   public getById(id: number): Observable<Task> {

     //CRIA UMA VAR QUE RECEBE O CAMINHO PASSANDO O ID
     let url = `${this.tasksUrl+"taskbyid"}/${id}`;

     return this.http.get(url)
       .catch(this.handleErrors)//FAZ O TRATAMENTO DO ERRO
       //RECEBE A RESPOSTA, CONVERTE EM JSON E SETA UMA TAREFA
       .map((response: Response) => {

        let collection = response.json();

        let task: Task;

        collection.forEach(item => {
          task = new Task(
            item.id,
            item.title,
            item.description,
            item.done,
            item.deadline
          );
        })
        
        return task;
       })
   }

   /**
    * createTask
    * MÉTODO RESPONSÁVEL POR CRIAR UMA TAREFA
    */
   public create(task: Task): Observable<Task> {
     let url  = this.tasksUrl+"addtask";
     //let body = JSON.stringify(task);

     //var obj = { title: task.title };

     let body = this.serializeObj(task);

     return this.http.post(url, body, {headers: this.headers})
            .catch(this.handleErrors)
            .map((response: Response) => {

              let collection = response.json();
              
              //console.log("Aqui: "+ collection[0].id);

              return new Task(
                collection[0].id,
                task.title)
             })
   }

    /**
    * updateTask
    * MÉTODO RESPONSÁVEL POR ATUALIZAR A TAREFA
    */
   public update(task: Task): Observable<Task> {
     let url  = `${this.tasksUrl+"updatetask"}/${task.id}`;//CAMINHO
     //let body = JSON.stringify(task);//TRANSFORMA E STRING NO FORMATO JSON

     let body = this.serializeObj(task);

     console.log(body);

     return this.http.put(url, body, {headers: this.headers}) //PASSA A URL, BODY E O HEADERS
            .catch(this.handleErrors) //TRATAR ERROS
            .map((response: Response) => {

              let collection = response.json();
              
              //console.log("Aqui: "+ collection[0].id);

              return new Task(
                collection[0].id,
                task.title,
                task.description,
                task.done,
                task.deadline)
             })
   }

   /**
    * deleteTask
    * MÉTODO RESPONSÁVEL PARA EXCLUIR A TAREFA
    */
   public delete(id: number): Observable<null> {
     let url = `${this.tasksUrl+"deletetask"}/${id}`;

     return this.http.delete(url, {headers: this.headers})
            .catch(this.handleErrors)
            .map(() => null);
   }

   public deleteMultiplos(ids: any[]): Observable<null>{

    let idsString = "";

    ids.forEach(element => {

        if(idsString == ""){
          idsString += element;
        }else{
          idsString += "e"+element;
        }      
    });

    let url = `${this.tasksUrl+"deletemultiplastasks"}/${idsString}`;

    return this.http.delete(url, {headers: this.headers})
           .catch(this.handleErrors)
           .map(() => null);
   }

   upload(formData: any) {

    let url = `${this.tasksUrl+"upload"}`;

    //let body = this.serializeObj(formData);

    //console.log("Serializado: "+body)

    return this.http.post(url, formData, {headers: this.headers})
    .catch(this.handleErrors)
    .map((response: Response) => {

      response.json();

     })
  }

   /**
    * searchByTitle
    */
   public searchByTitle(term: string): Observable<Task[]> {
     
    let url = `${this.tasksUrl+"taskbytitle"}/${term}`;

    // return this.http.get(url)
    //            .catch(this.handleErrors)
    //            .map((response: Response) => response.json().data as Task[]);

    return this.http.get(url)
      .catch(null)//FAZ O TRATAMENTO DO ERRO
      .map((response: Response) => {
        let collection = response.json();
        let tasks: Task[] = [];

        //console.log(collection);

        collection.forEach(item => {
          let task = new Task(
            item.id,
            item.title,
            item.description,
            item.done,
            item.deadline
          );

          tasks.push(task);
        })

        return tasks;

      });
   }

  /**
 * MÉTODO RESPONSÁVEL PARA TRANFORMAR UM OBJETO LEGIVEL PARA A API RECEBER OS PARAMETROS
 * @param obj 
 */
  private serializeObj(obj) {
    var result = [];
    for (var property in obj)
        result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

    return result.join("&");
  }

   //MÉTODO RESPONSÁVEL PARA TRATAR OS ERROS
   private handleErrors(error: Response) {

    if(error.status == 404){
      alert("Nenhuma tarefa cadastrada!");
    }



     //console.log("SALVANDO O ERRO: ", error);
     return Observable.throw(error)
   }

  //MÉTODO RESPONSÁVEL PARA TRATAR OS ERROS
  private handleErrorsSearch(error: Response) {
    console.log("Não existe: ", error);
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// C:/xampp2/htdocs/angular-front/src/app/tasks/shared/task.service.ts